import { createSelector } from 'reselect';
import _ from 'lodash';

import CadminSlx   from 'app/selectors/company-admin/';
import EntitiesSlx from 'app/selectors/entities';

const selIsSavingAutomaticMatches             = state => state.companyAdmin.pageSettings.isSavingAutomaticMatches;
const selIsSavingSearchApprovedNonprofitsOnly = state => state.companyAdmin.pageSettings.isSavingSearchApprovedNonprofitsOnly;

const selBudget = createSelector(
  [CadminSlx.company, EntitiesSlx.budgets],
  (company, budgets) => {
    return budgets[company?.currentMatchBudgetId] || null;
  }
);

export default {
  isSavingAutomaticMatches: selIsSavingAutomaticMatches,
  isSavingSearchApprovedNonprofitsOnly: selIsSavingSearchApprovedNonprofitsOnly,
  budget: selBudget,
};
